import type { PropType } from "vue";

import { Size } from "@/abc-dsk/options";

export const size = {
  type: String as PropType<Size>,
  default: Size.Md
};
